module.exports = __webpack_public_path__ + "img/1401.255bb577.jpg";